import React, { Component, PropTypes } from 'react';
import GroupStore from 'stores/Group';
import AuthStore from 'stores/Auth';
import GroupActions from 'actions/Group';
import AppPage from 'components/AppPage';
import RulerBar from 'components/RulerBar';
import GroupDetail from 'components/Route/Group/Detail';
import ListDetail from 'components/Material/ListDetail';
import { mixin, RefluxMixin, Authorizer } from 'Util';
import {
  FloatingActionButton,
  FlatButton,
  Dialog,
  TextField
} from 'material-ui';
import * as SvgIcons from 'components/Material/SvgIcons';
import Message from 'services/Message';

let { ContentAdd } = SvgIcons;

export default class Groups extends mixin(RefluxMixin, Authorizer, Component) {
  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  componentWillMount() {
    if (super.componentWillMount) {
      super.componentWillMount();
    }
    GroupActions.filter();
  }

  listenToStores() {
    this.listenToStore(GroupStore, 'groups');
    this.listenToStore(AuthStore, 'auth');
  }

  listenToActions() {
    this.listenToAction(GroupActions.findByIdComplete, group => {
      this.setState({ selected: group });
    });
    this.listenToAction(GroupActions.createComplete, group => {
      GroupActions.filter();
      this.setState({ selected: group });
    });
    this.listenToAction(GroupActions.updateComplete, group => {
      GroupActions.filter();
    });
  }
  resetFilter() {
    GroupActions.resetFilter();
    GroupActions.filter();
  }

  showCreateDialog() {
    this.refs.createDialog.show();
  }

  gotoGroup(group) {
    if (group === null) {
      this.setState({ selected: null });
    } else if (!this.selected || this.selected.id !== group.id) {
      GroupActions.findById(group.id);
    }
  }

  onConfirmCreate() {
    const grName = this.refs.groupName.getValue();
    if (grName.trim().length != 0) {
      GroupActions.create(this.refs.groupName.getValue());
      this.refs.createDialog.dismiss();
    } else {
      Message.info('Group name cannot be a space');
    }
  }

  render() {
    var groups = this.state.groups.list || [],
      detail;
    if (this.state.selected) {
      detail = (
        <GroupDetail
          key={this.state.selected.id}
          user={this.state.auth}
          group={this.state.selected}
          onClose={this.gotoGroup.bind(this, null)}
        />
      );
    }
    let standardActions = [
      <FlatButton
        key="ok"
        label={this.context.getIntlMessage('Create')}
        onTouchTap={this.onConfirmCreate.bind(this)}
      />
    ];

    let filterFunc = (item, searchText, labelProperty) => {
      if (searchText && searchText !== '') {
        return item[labelProperty].search(searchText) > -1;
      } else {
        return true;
      }
    };

    let addGroupButton = null;
    if (this.state.auth && this.state.auth.role.editor) {
      addGroupButton = (
        <div>
          <FloatingActionButton onTouchTap={this.showCreateDialog.bind(this)}>
            <ContentAdd />
          </FloatingActionButton>
        </div>
      );
    }

    return (
      <AppPage header={<RulerBar title="Groups" />} className={'group'}>
        <ListDetail
          items={groups}
          filter={filterFunc}
          onTouchTapItem={this.gotoGroup.bind(this)}
          floatingActionButton={addGroupButton}
        >
          {detail}
        </ListDetail>
        <Dialog
          ref="createDialog"
          title={this.context.getIntlMessage('group.create')}
          actions={standardActions}
          dismissOnClickAway={true}
        >
          <TextField
            ref="groupName"
            fullWidth={true}
            hintText={this.context.getIntlMessage('group.name')}
            onChange={this.onChange}
            floatingLabelText={this.context.getIntlMessage('group.name')}
          />
        </Dialog>
      </AppPage>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Route/Groups.js